import { useState } from 'react';
import { View } from '../../common';
import { RupeeInputField } from '../../components';
import { ProductVariant } from '@zonofi/zono-money-store';
import { PriceUpdatedProduct, ProductPriceUpdateMap } from '../../types';
import {
  toMajorCurrency,
  toMinorCurrency,
} from '@zonofi/common/functions/format-amount';

interface EditPriceFieldsProps {
  product: ProductVariant;
  updatedProducts?: ProductPriceUpdateMap;
  onUpdatePrice?: (item: PriceUpdatedProduct) => void;
}

export const EditPriceFields: React.FC<EditPriceFieldsProps> = ({
  product,
  updatedProducts,
  onUpdatePrice,
}) => {
  const currentProduct = updatedProducts?.[product.id.toString()];
  const initialPrice = toMajorCurrency(
    (currentProduct ? currentProduct?.price : product?.price) ?? 0
  ).toString();

  const [price, setPrice] = useState(initialPrice);

  const update = () => {
    if (Number(price) !== product?.price) {
      onUpdatePrice?.({
        pvId: product.id,
        productId: product.parentProductId ?? 0,
        price: toMinorCurrency(Number(price)),
        ptr: toMinorCurrency(Number(product.PTR)),
      });
    }
  };

  return (
    <View className="product-edit-price-view">
      <RupeeInputField
        value={price}
        onChange={setPrice}
        onInputBlur={update}
        inputWidth={60}
        inputHeight={30}
      />
    </View>
  );
};
